var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.106,
    height: 12.105,
    viewBox: "0 0 12.106 12.105",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Edit_icon",
    "data-name": "Edit icon",
    transform: "translate(-690.807 -18.072)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10009",
    "data-name": "Path 10009",
    d: "M182.476,74.45a.4.4,0,0,0-.107.2l-.553,2.766a.391.391,0,0,0,.384.468.372.372,0,0,0,.077-.008l2.765-.553a.389.389,0,0,0,.2-.107l6.188-6.188-2.765-2.765Zm0,0",
    transform: "translate(509 -47.705)",
    fill: "#7c7c7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10010",
    "data-name": "Path 10010",
    d: "M395.293,1.073a1.957,1.957,0,0,0-2.765,0l-1.082,1.082L394.21,4.92l1.082-1.083a1.955,1.955,0,0,0,0-2.765Zm0,0",
    transform: "translate(307.048 17.571)",
    fill: "#7c7c7c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditicon);
export default __webpack_public_path__ + "static/media/Edit icon.e4a1ae511dfc3f05f4df4246116552c1.svg";
export { ForwardRef as ReactComponent };